import gql from 'graphql-tag'

export const fetchAutopayPaymentMethodsQuery = gql(`
query getPaymentInformation($cartId: String!) {
  cart(cart_id: $cartId) {
    id
    selected_payment_method {
      code
      __typename
    }
    ...AvailablePaymentMethodsFragment
    __typename
  }
}
fragment AvailablePaymentMethodsFragment on Cart {
  id
  available_payment_methods {
    code
    title
    gateway_id
    __typename
  }
  __typename
}
`)
